import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import cx from 'classnames';

import { Table } from '@common/components/Table';
import { Button } from '@common/components/Button';
import { shallowIncludes } from '@common/utils/array';

import './Documents.styles.scss';

export class Documents extends React.Component {
  state = {
    documentURL: undefined,
    viewedDocsId: [],
  };

  handleOpenDocument = (e) => {
    const { id, url } = e.currentTarget.dataset;
    this.setState((state) => ({ 
      ...state, 
      documentURL: url,
      viewedDocsId: state.viewedDocsId.includes(id) ? state.viewedDocsId : [...state.viewedDocsId, id],
    }));
  }

  closeDocument = () => {
    this.setState((state) => ({ ...state, documentURL: undefined }));
  }

  get columns() {
    return [
      { Header: 'Name', accessor: 'documentType', minWidth: 220 },
      { Header: 'Date', accessor: 'createdDate', minWidth: 80 },
      { 
        Header: 'View', 
        accessor: 'view',
        minWidth: 60,
        Cell: ({ original: { url, previouslyDownloaded, id } }) => {
          return (
            <button 
              data-id={id}
              data-url={url}
              className={cx('Documents__doc-btn', { 'Documents__doc-btn--viewed': previouslyDownloaded || shallowIncludes(this.state.viewedDocsId, id) })} 
              onClick={this.handleOpenDocument}
            >
              <i className="fa fa-file-text-o" />
            </button>
          );
        }
      },
    ].map((x) => ({ ...x, Header: I18n.t(x.Header) }));
  }

  handleClose = () => {
    this.props.onClose(this.state.viewedDocsId);
  }

  render() {
    const { patientName, ambryDocuments, clientDocuments } = this.props;

    return (
      <React.Fragment>
        <Modal 
          show={Boolean(this.state.documentURL)}
          animation={false}
          backdrop="static"
          bsClass="bootstrap modal"
          dialogClassName="Document-preview"
          onEscapeKeyDown={this.closeDocument}
          onHide={this.closeDocument}
        >
          <ModalHeader closeButton onHide={this.closeDocument}>
            <ModalTitle id="lbl-order-status-results-header">
              {I18n.t('Open Status Results')}
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <iframe src={this.state.documentURL} width="100%" height="100%" />
          </ModalBody>

          <ModalFooter>
            <Button
              id="btn-order-status-results-cancel"
              onClick={this.closeDocument}
            >
              {I18n.t('Close')}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal 
          show 
          animation={false}
          className="Documents" 
          backdrop="static"
          bsClass="bootstrap modal"
          dialogClassName="Documents"
          onEscapeKeyDown={this.handleClose}
          onHide={this.handleClose}
        >
          <ModalHeader closeButton onHide={this.handleClose}>
            <ModalTitle id="msg-box-header">
              {I18n.t('Documents for')} {patientName}
            </ModalTitle>
          </ModalHeader>

          <ModalBody>
            <h5 className="Documents__title">{I18n.t('Documents Added by Ambry')}</h5>
            <Table
              disableAutoInit
              serverSorting={false}
              noDataMessage={I18n.t('There no documents to display')}
              config={{
                resizable: false,
                data: ambryDocuments,
                columns: this.columns,
              }}
              className="Documents__table"
            />

            <h5 className="Documents__title">{I18n.t('Client Uploaded Documents')}</h5>
            <Table
              disableAutoInit
              serverSorting={false}
              noDataMessage={I18n.t('There no documents to display')}
              config={{
                resizable: false,
                data: clientDocuments,
                columns: this.columns,
              }}
              className="Documents__table"
            />
          </ModalBody>

          <ModalFooter>
            <Button
              id="btn-ambry-link-order-dlg-cancel"
              onClick={this.handleClose}
            >
              {I18n.t('Close')}
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

